module.exports = __webpack_public_path__ + "img/no-positions-dark.bee69ccc.svg";